<div
  class="col se-p second-level-menu scroll-bar elibrary-left"
  [ngClass]="{ 'hid-listwrapper': viewPurchaseCourseList }"
>
  <div class="tabs is-centered is-marginless is-small is-mobile display-flex">
    <ul>
      <li routerLinkActive="is-active">
        <a
          class="is-semibold is-small"
          [routerLink]="['/elibraryandcourse/e-library']"
          >All Course</a
        >
      </li>
      <li routerLinkActive="is-active">
        <a
          class="is-semibold is-small"
          [routerLink]="['/elibraryandcourse/purchase-course']"
          >Purchased Course</a
        >
      </li>
    </ul>
  </div>

  @if (showSearchSec) {
  <div class="menu-options level is-marginless display-flex">
    <div class="level-left">
      <div class="level-item">
        <div class="select is-small">
          <select [(ngModel)]="sortBy" (change)="getPurchaseCourse(0)">
            <option value="name">Sort A to Z</option>
            <option value="time">Sort by Recent</option>
          </select>
        </div>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <a class="button is-small" (click)="showSearchBox('open')">
          <i class="fa fa-search"></i>
        </a>
      </div>
    </div>
  </div>
  } @if (!showSearchSec) {
  <div class="menu-options level is-marginless searchBox-pad display-flex">
    <div class="level-left">
      <div class="level-item input-search-box">
        <div class="field">
          <p class="control has-icons-left has-icons-right">
            <input
              type="text"
              class="input"
              inputFocus
              [(ngModel)]="search"
              (keyup)="searchInList.next($event)"
              placeholder="Search here...."
            />
            <a class="icon is-small is-left" title="Search">
              <i class="fa fa-search"></i>
            </a>
            <span class="input-bar"></span>
          </p>
        </div>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <span
          class="icon is-small is-right search-return"
          (click)="showSearchBox('close')"
        >
          <i class="fa fa-times-circle"></i>
        </span>
      </div>
    </div>
  </div>
  }

  <div
    class="list-wrapper scroll-bar list-overflow scrollUserandGroup"
    appInfiniteScroll
    infinite-scroll
    [infiniteScrollDistance]="modalScrollDistance"
    [infiniteScrollThrottle]="modalScrollThrottle"
    [scrollWindow]="false"
    (scrolled)="fetchPurchaseCourseList()"
  >
    <ul class="notification-list">
      @for (group of purchaseCourseList; track group) {
      <li
        class="cursor-pointer pos-relative chat-list"
        routerLinkActive="active"
        [ngClass]="{ hideInactiveGroup: group.group_active === false }"
      >
        @if (group.chat_type == 'group') {
        <div class="columns is-gapless is-clearfix pos-relative">
          <div class="column is-one-quarter">
            @if (group.group_icon) {
            <img [src]="profileUrl + group.group_icon" />
            } @if (!group.group_icon) {
            <empty-uname
              [userName]="group.full_name"
              [liProfile]="true"
            ></empty-uname>
            }
          </div>
          <div class="column is-clearfix">
            <p class="is-size-6 list-active" [title]="group.full_name">
              {{ group.full_name }}
            </p>
            <div>
              @if (group.TotalLessonCount) {
              <small class="lesson">{{ group.TotalLessonCount }} Lessons</small>
              }
            </div>
            @if (group.unread_post_count) {
            <span class="badge-count">{{ group.unread_post_count }}</span>
            }
          </div>
          <div class="is-pulled-right">
            <span class="is-size-7 pos-relative">
              {{ group.TotalUserCount }}
              <i class="fa fa-users mar-t-2 mar-l-2" aria-hidden="true"></i>
            </span>
          </div>
        </div>
        }
      </li>
      }
      <pagination-loader
        [showFetchLoader]="showPaginateSpinner"
      ></pagination-loader>
    </ul>
  </div>
</div>
<div class="col th-p notification-content-wrapper">
  <!-- <header class="top-box-shadow">
  <div class="columns is-gapless is-vcentered is-mobile">
    <figure class="has-text-centered">
      <i class="fa fa-chevron-left" ></i>
    </figure>

    <div class="column is-4">
      <h3 class="is-marginless is-clearfix">
        <span class="is-size-6 has-text-weight-semibold ellipsis" style="max-width:80%;display:inline-block;" title="Cost Analysis">Cost Analysis
        </span>
        <small class="display-b is-size-7 text-clr-grey">Nov 30, 2020 1:12 PM</small>
      </h3>
    </div>

    <div class="column is-8 has-text-right">
      <div class="is-flex" style="justify-content:flex-end;">
        <div class="field" style="margin: 8px 10px;">

          <div class="control has-icons-left has-icons-right">
            <input class="input is-small" type="email" placeholder="Search" [(ngModel)]="search" (keyup)="searchSubject.next($event)">
            <span class="icon is-small is-left">
              <i class="fa fa-search"></i>
            </span>
            <span class="icon is-small is-right" *ngIf="search">
              <i class="fa fa-close" style="cursor: pointer;"></i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</header> -->

  <div class="contents pos-relative">
    <div
      class="notifications scroll-bar"
      appInfiniteScroll
      (reachedBottom)="onScrollDown()"
      infinite-scroll
      [infiniteScrollDistance]="modalScrollDistance"
      [infiniteScrollThrottle]="modalScrollThrottle"
      [scrollWindow]="false"
      (scrolled)="onScrollDown()"
    >
      <div class="library_tile_view">
        <div class="flex-container">
          @for (item of courseFileList; track item) {
          <div class="flex-item">
            <div class="card">
              <!-- <div class="card-image">
              <figure class="image is-4by4"  *ngIf="item.message_type === 'file'">
                <div *ngIf="item.file_type==='video' || item.file_type==='image'; else elseTemplate">
                  <img class="thumb_img" [src]="item.thumb_Url" (click)="secureFileVideo(item.message_id, item)">
                  <a class="thumb_play is-small" *ngIf="item.file_type==='video' || item.file_type==='audio' || item.file_type==='image'" (click)="secureFileVideo(item.message_id, item)">
                    <i class="fa " [ngClass]="{'fa-eye': item.file_type=='image', 'fa-play-circle-o': item.file_type!='image'}" aria-hidden="true"></i>
                  </a>
                </div>
                <ng-template #elseTemplate>
                  <div *ngFor="let ic of uploadFileIcons">
                    <div *ngIf="ic.name==item.file_ext">
                      <img class="tile_imgcenter" [src]="ic.icons" (click)="secureFileRead(item.message_id, item)">
                      <a class="thumb_play is-small" (click)="secureFileRead(item.message_id, item)">
                        <i class="fa " [ngClass]="{'fa-eye': item.file_type!='audio', 'fa-play-circle-o': item.file_type==='audio'}" aria-hidden="true"></i>
                      </a>
                    </div>
                  </div>
                </ng-template>
              </figure>
            </div> -->
              <!-- <div class="card-content">
            <div class="media">
              <div class="media-content">
                <div class="columns ">
                  <div class="column">
                    <p class="title is-7" *ngIf="item.message!='undefined'; else elseTemplate" [title]="item.message | linkify" [innerHTML]="item.message | linkify"></p>
                    <div class="fileBtnOptions has-text-right is-pulled-right is-4">
                      <div class="dropdown is-right" >
                        <div class="dropdown-trigger" >
                          <a class="is-small pad-5-10" >
                            <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                          </a>
                        </div>
                        <div class="dropdown-menu" id="dropdown-menu6" role="menu" (click)="$event.stopPropagation()">
                          <div class="dropdown-content">
                            <a class="dropdown-item" (click)="secureFileDownLoad(item)">
                              <i class="fa fa-download" aria-hidden="true"></i> Download
                            </a>
                            <a class="dropdown-item" (click)="deleteSecureFile(item.message_id)">
                              <i class="fa fa-trash" aria-hidden="true"></i> Delete
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                    <ng-template #elseTemplate>
                      <p class="title is-4">No Title</p>
                    </ng-template>
                    <p class="shared">{{item.shared_by}}</p>
                    <p class="subtitle is-6">{{item.created_at | date:'MMM d, y'}}</p>
                    <p class="subtitle is-6">
                      641K Views -
                      <span *ngIf="item.file_type==='video' || item.file_type==='audio'">5 min</span>
                      <span *ngIf="item.file_type!=='video' && item.file_type!=='audio'">5 min read</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div> -->
            </div>
          </div>
          }
        </div>
      </div>
    </div>
  </div>
</div>

<router-outlet></router-outlet>
